"use client";

import Image from "next/image";
import React, { useState } from "react";
import cart from "@/assets/imgs/store/myPurchases/cart.svg";
import { useRouter } from "next/navigation";
import Reyal from "@/assets/imgs/store/categories/reyalBlo.svg";
import vectorMostSellings from "@/assets/imgs/store/card/vectorMostSelling.png";
import { usePathname } from "next/navigation";
import { addToCart } from "@/utils/cart";
import Cookies from "js-cookie";
import Link from "next/link";
import { useTranslations } from "next-intl";
import defaultImage from "@/assets/icons/NewHomePage/default-event.png";
export default function StoreProductCard({ data }: any) {
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations("store");
  const [imageError, setImageError] = useState(false);
  const pendingCartItemKey = "pending_store_cart_item";

  const isDetailsPage = pathname.includes("/store/product-details");

  const product = {
    id: data?.id,
    product_id: data?.id,
    name: data?.name,
    price: data?.price,
    old_price: data?.old_price,
    quantity: data?.stock ?? 100,
    selectedQuantity: 1,
    image: data?.image,
    tag_id: isDetailsPage ? (data?.tag_id ?? null) : null,
  };

  const openLoginAndStorePendingItem = () => {
    window.localStorage.setItem(pendingCartItemKey, JSON.stringify(product));

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("login", "1");
    currentUrl.searchParams.delete("redirect");

    router.replace(
      `${currentUrl.pathname}?${currentUrl.searchParams.toString()}`,
    );
  };

  const handleAddToCart = () => {
    const token = Cookies.get("access_token");

    if (!token) {
      openLoginAndStorePendingItem();
      return false;
    }

    addToCart(product);
    return true;
  };

  return (
    <div className="flex h-full min-h-[218px] sm:min-h-[340px] md:min-h-[370px] w-full md:w-full max-w-[320px] flex-col rounded-[12px] md:rounded-2xl glass-effect shadow-[0_1px_5px_rgba(0,0,0,0.12)] overflow-hidden">
      <Link
        href={`/store/product-details/${data?.id}`}
        className="block w-full text-start"
      >
        <div className="relative w-full">
          <Image
            src={imageError ? defaultImage : data?.image || defaultImage}
            className="h-[104px] min-h-[150px] sm:h-[192px] sm:min-h-[192px] w-full rounded-t-[12px] md:rounded-t-2xl object-cover"
            alt={data?.name || "product"}
            width={100}
            height={130}
            onError={() => setImageError(true)}
          />

          {data?.label && (
            <p className="absolute top-3.5 right-3.5 card-label-glass text-white text-[12px] md:text-[14px] px-[20px] py-1.5 rounded-[12px] font-bold shadow-sm">
              {data.label}
            </p>
          )}
        </div>
      </Link>

      <div className="flex md:flex-1  flex-col  items-start px-1.5 pb-1.5 md:p-3 h-[102px]  ">
        <Link
          href={`/store/product-details/${data?.id}`}
          className="w-full text-start mt-1"
        >
          <h3 className="line-clamp-2 text-start text-[12px] sm:text-[14px] font-bold md:font-semibold text-[#D1D3D4] md:text-[24px] md:leading-[32px] ">
            {data?.name}
          </h3>
        </Link>

        <div className="mt-auto flex w-full flex-col md:gap-2 ">
          <Link
            href={`/store/product-details/${data?.id}`}
            className="flex items-center justify-start gap-0.5 md:gap-2"
          >
            <span className="text-[19px] font-bold text-[#D1D3D4] md:text-[24px]">
              {data?.price}
            </span>
            <span className="mt-1 text-[10px] sm:text-[12px] font-bold text-[#D1D3D4] line-through md:text-[16px]">
              {data?.old_price}
            </span>
            <Image
              src={Reyal}
              alt="reyal"
              width={20}
              height={20}
              className="h-2.5 w-2.5 md:h-5 md:w-5"
            />
          </Link>

          <div className="flex w-full items-center justify-start gap-2 md:gap-2">
            <button
              type="button"
              disabled={data?.out_of_stock}
              onClick={(e) => {
                e.stopPropagation();

                if (!handleAddToCart()) {
                  return;
                }

                router.push("/user/cart");
              }}
              className={`w-full h-[26px] sm:h-[28px] md:h-[38px] rounded-[4px] text-[12px] sm:text-[14px] font-medium text-[#D1D3D4] md:text-[18px] transition-all duration-300 ${
                data?.out_of_stock
                  ? "bg-[#BFBFBF] cursor-not-allowed"
                   : "bg-[#d9ac4f] hover:bg-[#c89632]"
              }`}
            >
              {data?.out_of_stock ? t("outOfStock") : t("buyNow")}
            </button>
            <button
              type="button"
              disabled={data?.out_of_stock}
              onClick={(e) => {
                e.stopPropagation();

                handleAddToCart();
              }}
              className={`flex h-[28px] w-[38px] items-center justify-center rounded-[4px] md:h-[38px] md:w-[48px] transition-colors ${
                data?.out_of_stock
                  ? "bg-[#111111] opacity-50 cursor-not-allowed"
                   : "bg-[#d9ac4f]/10 hover:bg-[#d9ac4f]/20"
              }`}
              aria-label="Add product to cart"
            >
              <Image
                src={cart}
                alt="cart"
                width={32}
                height={32}
                className="h-[16px] w-[16px] object-contain md:h-[26px] md:w-[26px] brightness-0 invert"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
